import cn from "classnames";
import type { PrintFormDocumentType } from "helpers/printForms";
import React from "react";

interface ExternalPrintFormDownloadBtnProps {
    documentType: PrintFormDocumentType;
    loading: boolean;
    onClick: () => void;
}

const ExternalPrintFormDownloadBtn = ({ documentType, loading, onClick }: ExternalPrintFormDownloadBtnProps) => (
    <div className={cn({ "loading loading--small": loading })}>
        <button
            type="button"
            className={cn("btn inline-btn inline-btn--file inline-btn--print-form", { "inline-btn--disabled": loading })}
            disabled={loading}
            aria-busy={loading}
            onClick={onClick}
        >
            Скачать PDF {documentType === "waybill" ? "ЭТрН" : "ЭЗЗ"}
        </button>
    </div>
);

export default ExternalPrintFormDownloadBtn;
